/**
 * @generated SignedSource<<3e3b52f6e3ddca26147f1029f9c1f6af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationSubject"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationType"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rlimit"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewed"
},
v10 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "endTs",
        "variableName": "endDate"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "notificationSubject",
        "variableName": "notificationSubject"
      },
      {
        "kind": "Variable",
        "name": "notificationType",
        "variableName": "notificationType"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "rlimit",
        "variableName": "rlimit"
      },
      {
        "kind": "Variable",
        "name": "startTs",
        "variableName": "startDate"
      },
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      },
      {
        "kind": "Variable",
        "name": "viewed",
        "variableName": "viewed"
      }
    ],
    "concreteType": "NotificationEntriesConnection",
    "kind": "LinkedField",
    "name": "getnotificationentriesforuser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserInfoNotificationsQuery",
    "selections": (v10/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserInfoNotificationsQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "0af1d974e9d984eb8e813e759761d302",
    "id": null,
    "metadata": {},
    "name": "UserInfoNotificationsQuery",
    "operationKind": "query",
    "text": "query UserInfoNotificationsQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $accountId: UUID\n  $userId: UUID\n  $notificationType: String\n  $notificationSubject: String\n  $viewed: Int\n  $rlimit: Int\n  $first: Int\n  $offset: Int\n) {\n  getnotificationentriesforuser(startTs: $startDate, endTs: $endDate, accountId: $accountId, userId: $userId, notificationType: $notificationType, notificationSubject: $notificationSubject, viewed: $viewed, rlimit: $rlimit, first: $first, offset: $offset) {\n    totalCount\n  }\n}\n"
  }
};
})();

node.hash = "41630728b4fbedff21fb0ef1009f4ec1";

module.exports = node;
